module.exports = __webpack_public_path__ + "img/rewards-notification-bg-2.52e8dcf3.png";